<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10 0C15.5242 0 20 4.47581 20 10C20 15.5242 15.5242 20 10 20C4.47581 20 2.44379e-06 15.5242 2.44379e-06 10C2.44379e-06 4.47581 4.47581 0 10 0ZM10 3.87097C8.04032 3.87097 6.45161 5.45968 6.45161 7.41935C6.45161 9.37903 8.04032 10.9677 10 10.9677C11.9597 10.9677 13.5484 9.37903 13.5484 7.41935C13.5484 5.45968 11.9597 3.87097 10 3.87097ZM10 17.7419C12.3669 17.7419 14.4879 16.6694 15.9073 14.9919C15.1492 13.5645 13.6653 12.5806 11.9355 12.5806C11.8387 12.5806 11.7419 12.5968 11.6492 12.625C11.125 12.7944 10.5766 12.9032 10 12.9032C9.42339 12.9032 8.87097 12.7944 8.35081 12.625C8.25807 12.5968 8.16129 12.5806 8.06452 12.5806C6.33468 12.5806 4.85081 13.5645 4.09274 14.9919C5.5121 16.6694 7.63307 17.7419 10 17.7419Z"
			:fill="computedFill"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconUserProfile',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
